import { NavLink } from 'react-router-dom'
import css from './shell.module.css'

/** Phone navigation. 48px minimum height, per product rule 5. */
export function MobileTabBar() {
  return (
    <nav className={css.tabBar}>
      {[
        { to: '/lanes', label: 'Lanes' },
        { to: '/inbox', label: 'Inbox' },
        { to: '/activity', label: 'Activity' },
      ].map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          className={({ isActive }) => (isActive ? `${css.tabBarItem} ${css.tabBarActive}` : css.tabBarItem)}
        >
          {tab.label}
        </NavLink>
      ))}
    </nav>
  )
}
